// eBay Trading API (legacy XML) — coverage. Grounded in
// server/src/channels/ebay/trading.js. Two calls: a member-message write and an
// international-shipping read. Both use the user OAuth token (getAccessToken());
// the only difference is delivery (XML body vs. IAF header).
export default {
  api: 'eBay Trading API (legacy XML)',
  blurb:
    'Two operations against POST /ws/api.dll. addMemberMessageAAQToPartner sends a seller→buyer message (write, gated by EBAY_WRITE_ENABLED); isInternationalOrder/GetOrders reads multi-leg shipping (read, gated by EBAY_POST_ORDER_READ_ENABLED). Both authenticate with the same user OAuth token — the message embeds it as <eBayAuthToken> in the XML body; GetOrders sends it via the X-EBAY-API-IAF-TOKEN header. Nothing persisted.',
  endpoints: [
    {
      verb: 'POST', path: '/ws/api.dll  (X-EBAY-API-CALL-NAME: AddMemberMessageAAQToPartner)', fn: 'addMemberMessageAAQToPartner()', rw: 'write',
      params: [
        { p: 'ItemID', req: 'required', send: 'gated', val: 'eBay listing/item id for the transaction' },
        { p: 'MemberMessage.Body', req: 'required', send: 'gated', val: 'Message text (plain text — eBay blocks HTML here)' },
        { p: 'MemberMessage.RecipientID', req: 'required', send: 'gated', val: "Buyer's eBay username" },
        { p: 'MemberMessage.Subject', req: 'optional', send: 'gated', val: "default 'Message from Seller'" },
        { p: 'MemberMessage.QuestionType', req: 'required', send: 'gated', val: "'General'" },
        { p: 'RequesterCredentials.eBayAuthToken', req: 'required', send: 'gated', val: 'getAccessToken() — masked out of the logged body' },
      ],
      fields: [
        { f: 'Ack', pull: true, db: null, note: 'Success/Failure checked; Failure throws EbayTradingError with the ShortMessage', badge: 'pull' },
        { f: 'Errors.ShortMessage', pull: true, db: null, note: 'Surfaced in the thrown error on Ack=Failure', badge: 'pull' },
      ],
    },
    {
      verb: 'POST', path: '/ws/api.dll  (X-EBAY-API-CALL-NAME: GetOrders)', fn: 'isInternationalOrder()', rw: 'read',
      params: [
        { p: 'OrderIDArray.OrderID', req: 'required', send: 'y', val: 'eBay order id (paymentId from TRQ)' },
        { p: 'X-EBAY-API-IAF-TOKEN (header)', req: 'required', send: 'y', val: 'getAccessToken() — raw, no "IAF " prefix; no RequesterCredentials in the body' },
      ],
      fields: [
        { f: 'OrderArray.Order.IsMultiLegShipping', pull: true, db: null, note: 'true → international; null if the field is absent (never guesses)', badge: 'pull' },
        { f: 'other Order fields', pull: false, db: null, note: 'GetOrders returns the full order; only IsMultiLegShipping is read', badge: 'avail' },
      ],
    },
  ],
}
